export enum ContentPromotionContentSource {
  Monolith = "monolith",
  Langston = "langston",
}
